<template>
    <div class="layout-reminder-download" v-bind:class="{'layout-reminder-download-all': showQrCode}">
        <!-- 1、提示下载弹框 -->
        <div v-if="showDownPop" class="layout-reminder-download-top-pop dsp-flex">
            <div class="layout-rdtp-left">
                <span class="layout-rdtp-icon"></span>
            </div>
            <div class="layout-rdtp-middle layout-rdtp-middle-down">
                <p class="layout-rdtp-note-big">木火八字  免费专业好用</p>
                <p class="layout-rdtp-note-small">易学大数据  世代永相传</p>
            </div>
            <div class="layout-rdtp-right">
                <span class="layout-rdtp-button layout-rdtp-button-green" @click="clickCollate">智能测算</span>
            </div>
            <div class="layout-rdtp-right">
                <span class="layout-rdtp-button" @click="clickDownload">下载</span>
            </div>
            <div class="layout-rdtp-close" @click="clickDownClose">
                <i class="iconfont icon-close-solid"></i>
            </div>
        </div>

        <!-- 2、提示关注弹框 -->
        <div v-if="showAttentionPop && !showQrCode && CONFIG.platform == 'wechat'" class="layout-reminder-download-top-pop dsp-flex">
            <div class="layout-rdtp-left">
                <span class="layout-rdtp-icon"></span>
            </div>
            <div class="layout-rdtp-middle">
                <p class="layout-rdtp-note-big">天时子平八字</p>
                <p class="layout-rdtp-note-small">
                    <span class="layout-rdtp-note-small-s">免费专业好用的八字软件</span>
                </p>
            </div>
            <div class="layout-rdtp-right">
                <span class="layout-rdtp-button layout-rdtp-button-green" @click="clickCollate">智能测算</span>
            </div>
            <div class="layout-rdtp-right">
                <span class="layout-rdtp-button" @click="clickAttention">关注</span>
            </div>
            <div class="layout-rdtp-close" @click="clickAtClose">
                <i class="iconfont icon-close-solid"></i>
            </div>
        </div>

        <!-- 3、关注二维码弹框 -->
        <div class="layout-overlay" v-if="showQrCode"></div>
        <div class="layout-reminder-download-qrcode" v-if="showQrCode">
            <img class="layout-rdq-img" v-bind:src="qrCode" alt="">
            <p>长按识别二维码关注</p>
            <div class="layout-rdq-close" @click="clickQrCodeClose">
                <i class="iconfont icon-close"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config'
export default {
    name: 'ReminderDownload',
    computed: {},
    data() {
        return {
            CONFIG: CONFIG,
            showDownPop: false,
            showAttentionPop: false,
            showQrCode: false,
            qrCode: require('../../assets/images/qrcode.png')
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.checkDownStatus();
        }, 4000);
    },
    methods: {
        checkDownStatus() {
            var userData = this.$store.state.userData;
            console.log('ReminderDownload-------checkUserData-------', userData);
            console.log('appuser-----', userData.appuser);
            if(userData) {
                if(!userData.token) { return; }
                if(userData.appuser === 0) {
                    this.showDownPop = true;
                }else {
                    this.showDownPop = false;
                    this.checkAttentionStatus();
                }
            }
        },
        clickCollate() {
            this.showDownPop = false;
            this.showAttentionPop = false;
            var curPath = this.$router.history.current.path;
            if(curPath != '/collate') {
                this.$router.replace('/collate');
            }else {
                // 刷新当前页面
                window.location.reload();
            }
        },
        clickDownload() {
            if(UA.isAndroid()) {       // 安卓下载地址
            }else if(UA.isIphone()) {       // IOS下载地址
            }
            window.location = CONFIG.download_url;
        },
        clickDownClose() {
            this.showDownPop = false;
            var me = this;
            setTimeout(() => {
                me.checkAttentionStatus();
            }, 2000);
        },
        checkAttentionStatus() {
            var userData = this.$store.state.userData;
            if(userData && userData.isSubscribe && userData.isSubscribe != 1) {
                this.showAttentionPop = true;
            }
            console.log('checkAttentionStatus------isSubscribe----', this.showAttentionPop);
        },
        clickAttention() {
            this.showQrCode = true;
        },
        clickAtClose() {
            this.showAttentionPop = false;
        },
        clickQrCodeClose() {
            this.showQrCode = false;
        }
    }
}
</script>